import { formatCurrency } from '../../../../../utils/formatUtils';

type PendingAmountMessageProps = {
  pendingAmount?: number;
  targetAmount?: number;
  targetLabel: string;
};

const PendingAmountMessage = ({
  pendingAmount,
  targetAmount,
  targetLabel,
}: PendingAmountMessageProps) => {
  if (!pendingAmount) {
    return null;
  }

  const isOver = pendingAmount < 0 !== (targetAmount ?? 0) < 0;

  return (
    <label className="ml-2 font-bold p-error">
      {isOver
        ? `${formatCurrency(Math.abs(pendingAmount))} over the ${targetLabel}`
        : `${formatCurrency(
            Math.abs(pendingAmount)
          )} remaining to reach the ${targetLabel}`}
    </label>
  );
};

export default PendingAmountMessage;
